<template>
    <div class="rejectAudit">
        <el-dialog title="拒绝" :visible.sync="dialogVisible" width="600px">
            <p class="rejectReason">输入拒绝的理由：</p>
            <el-input placeholder="请输入内容" v-model.trim="authdesp"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="affirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import {auditPassRejectReturn} from '@/api/extensionAgent'
export default {
    name: 'rejectAudit',
    data() {
        return {
            dialogVisible: false,
            innerid: '',
            authdesp: ''
        }
    },
    methods: {
        rejectAudit(row) {
            this.dialogVisible = true
            this.innerid = row.innerid
        },
        affirm() {
            this.setLoading(true)
            auditPassRejectReturn({
                data: {innerid: this.innerid, authdesp: this.authdesp, status: '11'},
                success: data => {
                    this.dialogVisible = false
                    this.$message({
                        type: 'success',
                        message: '拒绝成功！'
                    })
                    this.$emit('getList')
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang="scss">
    .rejectAudit{
        .el-dialog{
            .el-input{
                margin-top: 10px;
            }
        }
    }
</style>